import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { EntryPointService, ProcessFilter, ProcessService } from '@mirage-projects/cw-commons';
import { CollageProcess, CollageProcessResponse } from '@mirage-projects/cw-models';

/**
 * Service implementation to manage the process endpoints
 */
@Injectable({
    providedIn: 'root',
})
export class AppProcessService implements ProcessService {
    constructor(
        private http: HttpClient,
        private entryPointService: EntryPointService
    ) { }

    /**
     * Filter the processes
     */
    filter(processFilter: ProcessFilter): Observable<CollageProcessResponse> {
        const url = `${this.entryPointService.getPublicApiUrl()}/process/metadata`;
        const params = new HttpParams({ fromObject: processFilter as any });

        return this.http
            .get<CollageProcess[]>(url, {
                params,
                observe: 'response',
            })
            .pipe(
                map((response: any) => {
                    const total = Number(response.headers.get('X-Total-Count'));
                    return {
                        items: response.body ?? [],
                        total,
                    };
                })
            );
    }

    get(uuid: string): Observable<CollageProcess> {
        const url = `${this.entryPointService.getPublicApiUrl()}/process/metadata/${uuid}`;
        return this.http.get<CollageProcess>(url);
    }

    cancel(uuid: string): Observable<void> {
        const url = `${this.entryPointService.getPublicApiUrl()}/process/metadata/${uuid}/cancel`;
        return this.http.post<void>(url, {});
    }

    /**
     * Get Collage Process by its external ID
     * @param processUuid
     */
    getByExternal(processUuid: string): Observable<CollageProcess> {
        const url = `${this.entryPointService.getPublicApiUrl()}/process/external/${processUuid}`;
        return this.http.get<CollageProcess>(url, {});
    }
}
